import { isAxiosError } from "axios";
import { handleApiError } from "@/services/api";
import type { MerchantFlowError } from "../types";

/** S7 / S8 error codes. Anything else falls back to the API's own message. */
const ACTION_ERROR_MESSAGES: Record<string, string> = {
  flow_not_open: "This flow is no longer open.",
  flow_expired: "This link has expired. Send a new flow instead.",
  email_blocked: "The recipient address is blocked, so the invite was not sent.",
  email_failed: "The invite could not be sent. Try again.",
};

export function flowActionErrorMessage(err: unknown): string {
  if (!isAxiosError(err)) return err instanceof Error ? err.message : "Something went wrong.";
  const code = (err.response?.data as MerchantFlowError | undefined)?.error;
  return (code && ACTION_ERROR_MESSAGES[code]) || handleApiError(err);
}
